import { render, staticRenderFns } from "./SetAmazonAssumeRoleCredentialsDialog.vue?vue&type=template&id=85b69f78&"
import script from "./SetAmazonAssumeRoleCredentialsDialog.vue?vue&type=script&lang=js&"
export * from "./SetAmazonAssumeRoleCredentialsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports